export enum IdentityTypeIdEnum {
  Member = 1,
  NonMember = 2
}
